import React, { useEffect, useRef, useState } from "react";
import { BasePageModal } from "@/shared/components/modal/page-modal/base-page-modal";
import { BaseRoundButton } from "@/shared/components/button/base-round-button";
import { useAccountGroupsContext } from "@/features/accounts/account-group/contexts/account-groups-context";
import { useUpdateAccountGroupsShare } from "@/features/accounts/account-group/hooks/use-update-account-group-share";


interface Props {
  onTapCloseModal: () => void;
}

export const InvitedGroupModal = ({ onTapCloseModal }: Props) => {
  const {
    invitedAccountGroups,
    setInvitedAccountGroups,
  } = useAccountGroupsContext();
  const {
    updateAccountGroupsShare,
  } = useUpdateAccountGroupsShare();

  useEffect(() => {
    if (invitedAccountGroups.length === 0) {
      onTapCloseModal();
    }
  }, [invitedAccountGroups]);

  const currentInvitation = invitedAccountGroups[0];
  const totalCount = useRef(invitedAccountGroups.length);
  const [processedCount, setProcessedCount] = useState(0);

  const handleInvitationAction = (status: 1 | 2) => {
    if (!currentInvitation) {
      return;
    }

    updateAccountGroupsShare(
      currentInvitation.accountGroupId,
      currentInvitation.sharedId,
      status
    );

    setInvitedAccountGroups((prev) => prev.slice(1));
    setProcessedCount((prev) => prev + 1);
  };

  return (
    <BasePageModal
      handleClose={onTapCloseModal}
      title={totalCount.current > 1 ? `グループに招待されました（${processedCount + 1}/${totalCount.current}）` : "グループに招待されました"}
      className="md-info-invitation"
      bottomChildren={
        <>
          <BaseRoundButton
            buttonText="承認"
            className="btn"
            onClick={() => {
              handleInvitationAction(1);
            }}
          />
          <BaseRoundButton
            buttonText="拒否"
            className="btn"
            onClick={() => {
              handleInvitationAction(2);
            }}
          />
        </>
      }
    >
      {currentInvitation && (
        <>
        <h2>{currentInvitation.accountGroupName}</h2>
        <dl className="invitation">
          <dt>
            <span>招待者</span>
            <strong>{currentInvitation.ownerId}</strong>
          </dt>
          <dd></dd>
        </dl>
        </>
      )}
    </BasePageModal>
  );
};
